const FetchClient = require('./FetchClient')

class EmilyClient {
  /**
   * Create an EmilyClient
   * @param {string} baseUrl - baseUrl is prepended to the url and is based on environment
   */
  constructor (baseUrl) {
    if (!baseUrl) {
      throw Error('failed to initialize EmilyClient: missing baseUrl')
    }
    this.client = new FetchClient({ baseUrl })
  }

  getForm (formGuid) {
    return this.client.get(`/api/external/getForm/${formGuid}`)
  }

  submit (data) {
    const headers = {
      'content-type': 'application/x-www-form-urlencoded',
      'cache-control': 'no-cache'
    }
    const body = new URLSearchParams(data).toString()
    return this.client.post('/api/lead-submit', body, headers)
  }
}

module.exports = EmilyClient
